export default class WorkItemOptionListService {
  public static getColumnSaved(columnOptions: any[], item: string = this.getHeaderColumns()) {
    if (item.length !== 0) {
      const storedObjects = JSON.parse(item);
      storedObjects.forEach((storedObject: any) => {
        const foundOption = columnOptions.find(
          (option: any) => option.value === storedObject.value,
        );
        return foundOption.active = storedObject.active;
      });
    }
  }

  private static getHeaderColumns() {
    const options = window.localStorage.getItem('selected') as string;
    if (options) {
      return options;
    }
    return '';
  }
}
